<div class="alert alert-info" role="alert">
  <app-icon name="info-circle" class="me-2"></app-icon>
  <strong>Welcome!</strong> Please set up your username and password to complete your account setup.
</div>

<form [formGroup]="setupForm" (ngSubmit)="onSubmit()" [appSpinner]="isSubmitting">
  <div class="row">
    <div class="col-md-6">
      <div class="form-group mb-3">
        <label for="email" class="form-label">
          Email <span class="text-danger">*</span>
        </label>
        <input type="email" id="email" class="form-control" formControlName="email" placeholder="Enter your email"
          autocomplete="email">
        <app-validation-errors [control]="setupForm.get('email')" [submitted]="isFormSubmitted" fieldName="Email">
        </app-validation-errors>
        <app-server-validation-error [errors]="serverErrors" key="email">
        </app-server-validation-error>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-6">
      <div class="form-group mb-3">
        <label for="current_password" class="form-label">
          Current Password <span class="text-danger">*</span>
        </label>
        <div class="input-group">
          <input type="password" id="current_password" class="form-control" formControlName="current_password"
            placeholder="Enter your current password" autocomplete="new-password">
        </div>
        <app-validation-errors [control]="setupForm.get('current_password')" [submitted]="isFormSubmitted">
        </app-validation-errors>
        <app-server-validation-error [errors]="serverErrors" key="current_password">
        </app-server-validation-error>
      </div>
    </div>

    <div class="col-md-6">
      <div class="form-group mb-3">
        <label for="new_password" class="form-label">
          New Password <span class="text-danger">*</span>
        </label>
        <div class="input-group">
          <input type="password" id="new_password" class="form-control" formControlName="new_password"
            placeholder="Enter your new password" autocomplete="new-password">
        </div>
        <app-validation-errors [control]="setupForm.get('new_password')" [submitted]="isFormSubmitted">
        </app-validation-errors>
        <app-server-validation-error [errors]="serverErrors" key="new_password">
        </app-server-validation-error>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <button type="submit" class="btn btn-primary" [disabled]="isSubmitting">
        Complete Setup
      </button>
    </div>
  </div>
</form>